import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PropertyLandingPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  const handleCTA = () => {
    navigate('/property-upload');
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      {/* Hero Section */}
      <section className="relative py-20 px-4 overflow-hidden">
        {/* Animated Background */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-10 text-6xl animate-bounce" style={{animationDelay: '0s'}}>🏠</div>
          <div className="absolute top-40 right-20 text-5xl animate-bounce" style={{animationDelay: '1s'}}>💰</div>
          <div className="absolute bottom-32 left-1/4 text-7xl animate-bounce" style={{animationDelay: '2s'}}>🚀</div>
        </div>

        <div className="max-w-4xl mx-auto text-center relative z-10">
          <div className="inline-block bg-gradient-to-r from-[#e31937] to-red-600 text-white text-sm font-black px-6 py-2 rounded-full mb-6 animate-pulse">
            🔥 MOST INGYEN
          </div>
          
          <h1 className="text-5xl md:text-7xl font-black text-white mb-6 leading-tight">
            Add el gyorsabban a lakásod
            <span className="block bg-gradient-to-r from-[#e31937] via-red-500 to-orange-500 bg-clip-text text-transparent">
              AI segítségével
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-2xl mx-auto">
            ✔ Ingyenes feltöltés<br/>
            ✔ AI árbecslés<br/>
            ✔ Több érdeklődő
          </p>

          <button
            onClick={handleCTA}
            className="bg-gradient-to-r from-[#e31937] to-red-600 hover:from-red-600 hover:to-[#e31937] text-white font-black text-2xl px-12 py-6 rounded-2xl shadow-2xl hover:shadow-red-500/50 transition-all duration-300 hover:scale-105"
          >
            Feltöltöm most 🚀
          </button>

          <p className="text-gray-400 text-sm mt-4">
            ⏰ Ingyenes feltöltés csak most • Nincs rejtett költség
          </p>
        </div>
      </section>

      {/* Problem Section */}
      <section className="py-16 px-4 bg-gradient-to-b from-black to-[#0a0a0a]">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-black text-white text-center mb-12">
            Miért nem hívnak?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { icon: '💰', title: 'Rossz ár', desc: 'Túlárazva vagy alulértékelt' },
              { icon: '📸', title: 'Rossz képek', desc: 'Sötét, homályos, rendezetlen' },
              { icon: '🎬', title: 'Nincs videó', desc: 'A vevők videót akarnak látni' }
            ].map((item, index) => (
              <div key={index} className="bg-gradient-to-br from-red-500/20 to-orange-500/20 backdrop-blur-xl rounded-2xl p-6 border-2 border-red-500/30 text-center">
                <div className="text-5xl mb-4">{item.icon}</div>
                <h3 className="text-xl font-black text-white mb-2">{item.title}</h3>
                <p className="text-gray-300">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <p className="text-2xl font-bold text-red-400">
              👉 Ezért nem adod el
            </p>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-black text-white text-center mb-12">
            AI megmondja:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { icon: '💰', title: 'Mennyi az ára', desc: 'Piaci elemzés alapján' },
              { icon: '📸', title: 'Hogyan nézzen ki', desc: 'AI staging és optimalizálás' },
              { icon: '🎬', title: 'Kell-e videó', desc: 'Automatikus videó generálás' }
            ].map((item, index) => (
              <div key={index} className="bg-gradient-to-br from-green-500/20 to-emerald-500/20 backdrop-blur-xl rounded-2xl p-6 border-2 border-green-500/30 text-center">
                <div className="text-5xl mb-4">{item.icon}</div>
                <h3 className="text-xl font-black text-white mb-2">{item.title}</h3>
                <p className="text-gray-300">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Before/After Section */}
      <section className="py-16 px-4 bg-gradient-to-b from-black to-[#0a0a0a]">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-black text-white text-center mb-12">
            Előtte / Utána
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-red-500/20 to-orange-500/20 backdrop-blur-xl rounded-2xl p-6 border-2 border-red-500/30">
              <div className="text-center mb-4">
                <span className="bg-red-500 text-white text-sm font-black px-4 py-2 rounded-full">
                  ❌ ELŐTTE
                </span>
              </div>
              <div className="aspect-video bg-gray-800 rounded-xl flex items-center justify-center mb-4">
                <span className="text-6xl">🏚️</span>
              </div>
              <p className="text-gray-300 text-center">Üres, hideg, nem vonzó</p>
            </div>

            <div className="bg-gradient-to-br from-green-500/20 to-emerald-500/20 backdrop-blur-xl rounded-2xl p-6 border-2 border-green-500/30">
              <div className="text-center mb-4">
                <span className="bg-green-500 text-white text-sm font-black px-4 py-2 rounded-full">
                  ✓ UTÁNA
                </span>
              </div>
              <div className="aspect-video bg-gradient-to-br from-green-500/20 to-emerald-500/20 rounded-xl flex items-center justify-center mb-4">
                <span className="text-6xl">🏡</span>
              </div>
              <p className="text-gray-300 text-center">Otthonos, meleg, eladható</p>
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-black text-white text-center mb-12">
            Valós eredmények
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {[
              { quote: '"1 hét alatt elment"', name: 'Kovács Péter', location: 'Budapest' },
              { quote: '"3x több érdeklődő"', name: 'Nagy Éva', location: 'Debrecen' },
              { quote: '"Ingyen feltöltöttem"', name: 'Szabó Gábor', location: 'Szeged' }
            ].map((item, index) => (
              <div key={index} className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-2xl p-6 border-2 border-white/[0.08]">
                <div className="flex gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} className="text-yellow-400 text-xl">⭐</span>
                  ))}
                </div>
                <p className="text-white text-lg font-bold mb-3 italic">"{item.quote}"</p>
                <div className="text-gray-300 text-sm">
                  <div className="font-bold">{item.name}</div>
                  <div>{item.location}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 px-4 bg-gradient-to-r from-[#e31937] to-red-600">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
            🔥 Most ingyen
          </h2>
          
          <button
            onClick={handleCTA}
            className="bg-white text-[#e31937] font-black text-2xl px-12 py-6 rounded-2xl shadow-2xl hover:scale-105 transition-all duration-300"
          >
            Feltöltöm most
          </button>

          <p className="text-white/90 text-lg mt-6">
            ✓ 1 perc alatt kész • ✓ Nincs rejtett költség • ✓ AI elemzés ingyen
          </p>
        </div>
      </section>
    </div>
  );
};

export default PropertyLandingPage;
